// extracted by mini-css-extract-plugin
export var baseButton = "_wa-0";
export var controlsArrowKeys = "_wa-1";
export var controlsResetButton = "_wa-2";
export var lightGameButton = "_wa-4 _wa-0";
export var playAgainButton = "_wa-5 _wa-0";
export var startGameButton = "_wa-3 _wa-0";